<template>
    <div>
        <le-search-form @reset="handlerRest" @search="handlerSearch" >
            <le-input label="订单编号" v-model="pageParam.params.orderSn" placeholder="请输入订单编号" />
            <le-date-range 
                label="充值时间" 
                :minDate.sync="pageParam.params.startTime" 
                :maxDate.sync="pageParam.params.endTime" 
                valueFormat="yyyy-MM-dd HH:mm:ss" 
                :defaultTime="['00:00:00','23:59:59']" />
        </le-search-form>
        <le-pagview ref="userRechargePage" @setData="setTableData" :pageParam="pageParam" v-if="pageParam">
            <el-table :data="tabledata">
                <el-table-column label="订单编号" prop="typeText">
                    <template slot-scope="{ row }">
                        <span>{{ row.orderSn || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="充值金额" prop="content">
                    <template slot-scope="{ row }">
                        <span>￥{{ util.numFormat(row.payAmount) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="线上退款金额" prop="orderId">
                    <template slot-scope="{ row }">
                        <span>￥{{ util.numFormat(row.refundAmount) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="支付渠道" prop="activePower">
                    <template slot-scope="{ row }">
                        <span>{{ util.initDic(row.payChannel, 'payChannel') }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="充值状态" prop="operatorUserPhone">
                    <template slot-scope="{ row }">
                        <span>{{ util.initDic(row.orderStatus, 'orderStatus') }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="充值时间" prop="cardNo">
                    <template slot-scope="{ row }">
                        <span>{{ row.payTime || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作人" prop="createTimeText">
                    <template slot-scope="{ row }">
                        <span>{{ row.operateName || '-' }} {{ row.operatePhone || '-' }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </le-pagview>
    </div>
</template>

<script>
    import util from '@/utils/util.js'
    export default {
        data() {
            return {
                util: util,
                pageParam: {
                    url: this.$Config.apiUrl.userOrCardRechargePage,
                    method: "post",
                    params: {
                        "balanceId": this.userId,
                        "endTime": "",
                        "orderSn": "",
                        "payType": "0",
                        "startTime": "",
                        "userId": this.userId
                    },
                    freshCtrl: 1,
                },
                tabledata: [],
            }
        },
        props:['userId','phone'],
        mounted () {

        },
        methods:{
            handlerRest() {
                this.pageParam.params = {
                    "balanceId": this.userId,
                    "endTime": "",
                    "orderSn": "",
                    "payType": "0",
                    "startTime": "",
                    "userId": this.userId
                };
                this.handlerSearch()
            },
            handlerSearch() {
                this.$refs.userRechargePage.pageNum = 1
                this.pageParam.freshCtrl++;
            },
            setTableData (datas) {
                this.tabledata = datas.map(item=>{
                    return {
                        ...item,
                    }
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
   
</style>